import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancefhanbu89c1sm as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketEngine1lh73ie4wh0m5 as WebSocketEngine } from './WebSocketEngine.js.mjs';
import {
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { GraphQLWsProtocol3nqe2321ot0cb as GraphQLWsProtocol } from './GraphQLWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { awaitClose10k42f6qjplpu as awaitClose } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { WebSocketPool28m608awosr6h as WebSocketPool } from './internal/WebSocketPool.mjs';
import { callbackFlow1g384rkuy0hni as callbackFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ChannelResult2y4k69ac6y3du as ChannelResult } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$build$slambda() {
  return constructCallableReference(($completion) => orPromise($completion, function *($completion) {
    return null;
  }), 0);
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.serverUrl_1 = null;
        this.webSocketEngine_1 = null;
        this.wsProtocol_1 = null;
        this.connectionAcknowledgeTimeout_1 = null;
        this.pingInterval_1 = null;
        this.idleTimeout_1 = null;
        this.parserFactory_1 = null;
        this.incrementalDeliveryProtocol_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      serverUrl_kg2d9h_k$(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.serverUrl_1 = serverUrl;
        return this;
      }
      idleTimeout_i6w53x_k$(idleTimeout) {
        // Inline function 'kotlin.apply' call
        this.idleTimeout_1 = idleTimeout;
        return this;
      }
      build_1k0s4u_k$() {
        var tmp0_elvis_lhs = this.webSocketEngine_1;
        var tmp5_webSocketEngine = tmp0_elvis_lhs == null ? WebSocketEngine() : tmp0_elvis_lhs;
        var tmp6_serverUrl = this.serverUrl_1;
        var tmp1_elvis_lhs = this.idleTimeout_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(60, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp7_idleTimeout = tmp;
        var tmp2_elvis_lhs = this.wsProtocol_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp_1 = new (GraphQLWsProtocol())(WebSocketNetworkTransport$Builder$build$slambda());
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp8_wsProtocol = tmp_1;
        var tmp9_pingInterval = this.pingInterval_1;
        var tmp3_elvis_lhs = this.connectionAcknowledgeTimeout_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp_2 = toDuration(10, DurationUnit_SECONDS_getInstance());
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var tmp10_connectionAcknowledgeTimeout = tmp_2;
        var tmp4_elvis_lhs = this.parserFactory_1;
        var tmp11_parserFactory = tmp4_elvis_lhs == null ? new (DefaultSubscriptionParserFactory())(get_impl(this.incrementalDeliveryProtocol_1)) : tmp4_elvis_lhs;
        return new (WebSocketNetworkTransport())(tmp5_webSocketEngine, tmp6_serverUrl, tmp8_wsProtocol, tmp10_connectionAcknowledgeTimeout, tmp9_pingInterval, tmp7_idleTimeout, tmp11_parserFactory);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
function WebSocketNetworkTransport$execute$slambda($renewUuid, $request, this$0) {
  return constructCallableReference(($this$callbackFlow, $completion) => orPromise($completion, function *($completion) {
    var tmp;
    if ($renewUuid._v) {
      tmp = $request.newBuilder_dnl2aj_k$().requestUuid_f5bk3d_k$(uuid4()).build_1k0s4u_k$();
    } else {
      tmp = $request;
    }
    var newRequest = tmp;
    $renewUuid._v = true;
    var operationListener = new (DefaultOperationListener())(newRequest, $this$callbackFlow, this$0.parserFactory_1.createParser_81qxa7_k$($request));
    var webSocket = this$0.pool_1.acquire_dgadfr_k$(newRequest);
    webSocket.startOperation_3pnjec_k$(newRequest, operationListener);
    yield* awaitClose($this$callbackFlow, () => {
      webSocket.stopOperation_2p8xpj_k$(newRequest);
      return Unit_instance;
    }, $completion);
    return Unit_instance;
  }), 1);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout, parserFactory) {
        this.webSocketEngine_1 = webSocketEngine;
        this.serverUrl_1 = serverUrl;
        this.wsProtocol_1 = wsProtocol;
        this.connectionAcknowledgeTimeout_1 = connectionAcknowledgeTimeout;
        this.pingInterval_1 = pingInterval;
        this.idleTimeout_1 = idleTimeout;
        this.parserFactory_1 = parserFactory;
        this.pool_1 = new (WebSocketPool())(this.webSocketEngine_1, this.serverUrl_1, this.wsProtocol_1, this.connectionAcknowledgeTimeout_1, this.pingInterval_1, this.idleTimeout_1);
      }
      execute_ngxta1_k$(request) {
        var renewUuid = {_v: false};
        var flow = callbackFlow(WebSocketNetworkTransport$execute$slambda(renewUuid, request, this));
        return buffer(flow, 2147483647);
      }
      dispose_3nnxhr_k$() {
        this.pool_1.close_yn9xrc_k$();
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport');
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function errorResponse($this, cause) {
  return Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$($this.request_1.operation_1, $this.request_1.requestUuid_1).exception_5qwc7n_k$(cause).build_1k0s4u_k$();
}
var DefaultOperationListenerClass;
function DefaultOperationListener() {
  if (DefaultOperationListenerClass === VOID) {
    class $ {
      constructor(request, producerScope, parser) {
        this.request_1 = request;
        this.producerScope_1 = producerScope;
        this.parser_1 = parser;
      }
      onResponse_1e8t5b_k$(response) {
        var tmp0_safe_receiver = this.parser_1.parse_eholak_k$(response);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.producerScope_1.trySend_62dpg8_k$(tmp0_safe_receiver);
          new (ChannelResult())(tmp$ret$0);
        }
      }
      onComplete_9lqbvc_k$() {
        this.producerScope_1.close$default_kcbl7u_k$();
      }
      onError_eftw4m_k$(payload) {
        this.producerScope_1.trySend_62dpg8_k$(errorResponse(this, SubscriptionOperationException().new_com_apollographql_apollo_exception_SubscriptionOperationException_du4zxk_k$(this.request_1.operation_1.operationName(), payload)));
        this.producerScope_1.close$default_kcbl7u_k$();
      }
      onTransportError_yet6bv_k$(cause) {
        this.producerScope_1.trySend_62dpg8_k$(errorResponse(this, cause));
        this.producerScope_1.close$default_kcbl7u_k$();
      }
    }
    initMetadataForClass($, 'DefaultOperationListener');
    DefaultOperationListenerClass = $;
  }
  return DefaultOperationListenerClass;
}
var DefaultSubscriptionParserFactoryClass;
function DefaultSubscriptionParserFactory() {
  if (DefaultSubscriptionParserFactoryClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl) {
        this.incrementalDeliveryProtocolImpl_1 = incrementalDeliveryProtocolImpl;
      }
      createParser_81qxa7_k$(request) {
        return new (DefaultSubscriptionParser())(this.incrementalDeliveryProtocolImpl_1, request);
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParserFactory');
    DefaultSubscriptionParserFactoryClass = $;
  }
  return DefaultSubscriptionParserFactoryClass;
}
var DefaultSubscriptionParserClass;
function DefaultSubscriptionParser() {
  if (DefaultSubscriptionParserClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl, request) {
        this.request_1 = request;
        this.incrementalResultsMerger_1 = incrementalDeliveryProtocolImpl.newIncrementalResultsMerger_frcl62_k$();
        var tmp = this;
        var tmp0_elvis_lhs = this.request_1.executionContext_1.get_ourcpn_k$(Key_getInstance());
        tmp.requestCustomScalarAdapters_1 = tmp0_elvis_lhs == null ? Key_getInstance().Empty_1 : tmp0_elvis_lhs;
      }
      parse_eholak_k$(response) {
        var responseMap = (!(response == null) ? isInterface(response, KtMap()) : false) ? response : null;
        if (responseMap == null) {
          return Builder().new_com_apollographql_apollo_api_ApolloResponse_Builder_h8chhh_k$(this.request_1.operation_1, this.request_1.requestUuid_1).exception_5qwc7n_k$(DefaultApolloException().new_com_apollographql_apollo_exception_DefaultApolloException_6xe6ia_k$('Invalid payload')).build_1k0s4u_k$();
        }
        var tmp;
        if (isDeferred(responseMap)) {
          tmp = to(this.incrementalResultsMerger_1.merge_uizp56_k$(responseMap), this.incrementalResultsMerger_1.get_deferredFragmentIdentifiers_ylh6by_k$());
        } else {
          tmp = to(responseMap, null);
        }
        var _destruct__k2r9zo = tmp;
        var payload = _destruct__k2r9zo.component1_7eebsc_k$();
        var deferredFragmentIdentifiers = _destruct__k2r9zo.component2_7eebsb_k$();
        var apolloResponse = toApolloResponse(jsonReader(payload), this.request_1.operation_1, this.request_1.requestUuid_1, this.requestCustomScalarAdapters_1, deferredFragmentIdentifiers);
        if (!this.incrementalResultsMerger_1.get_hasNext_csdx38_k$()) {
          this.incrementalResultsMerger_1.reset_5u6xz3_k$();
        }
        var tmp_0;
        if (this.incrementalResultsMerger_1.get_isEmptyResponse_kjiv23_k$()) {
          tmp_0 = null;
        } else {
          tmp_0 = apolloResponse;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParser');
    DefaultSubscriptionParserClass = $;
  }
  return DefaultSubscriptionParserClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.get_keys_wop4xp_k$().contains_aljjnj_k$('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder1suvx83rlbrz1,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
